import { useQuery } from '@tanstack/react-query'
import { getCompanyLogs } from 'api/company'
import { useAuthContext } from 'components/auth'
import { QueryFnParams, QueryOptions } from 'queries/types'
import { companyLogsKey } from './keys'

export function useCompanyLogs(
  {
    startDate,
    endDate,
  }: Pick<QueryFnParams<typeof getCompanyLogs>[0], 'startDate' | 'endDate'>,
  options: QueryOptions<typeof getCompanyLogs> = {}
) {
  const { company } = useAuthContext()

  return useQuery({
    ...options,
    queryKey: companyLogsKey(startDate, endDate),
    queryFn: () => {
      if (!company?.id) {
        throw new Error('Company ID not found')
      }
      return getCompanyLogs({ companyId: company.id, startDate, endDate })
    },
    enabled: Boolean(company?.id) && (options.enabled ?? true),
  })
}
